import { get, post } from '../../utils/request'

// 企业理念列表
const cultureLtIdeaIe = get('/news/heaIdea/api/list')

// 员工风采列表
const culturePeopleLtIe = get('/news/heaDemeanor/list')

// 培训提升列表
const cultrueUpIe = get('/news/heaTheory/api/list')
export {
  cultureLtIdeaIe,
  culturePeopleLtIe,
  cultrueUpIe
}



// WEBPACK FOOTER //
// ./src/api/culture/culture.js